import { IonPage } from "@ionic/react"
import {
  Editor,
  getSnapshot,
  Tldraw,
  exportToBlob,
  TLPageId,
  defaultShapeUtils,
  defaultBindingUtils,
} from "tldraw"

import { useCallback, useEffect, useRef, useState } from "react"
import { DrawStrokeTool } from "../tools/DrawStrokeTool"
import { useAppDispatch, useAppSelector } from "../app/hooks"
import { useLocation, useParams } from "react-router"
import { DrawingId } from "../entities"
//import { StickerShapeUtil } from "../shapes/StickerShapeUtil"
import { throttle } from "tldraw"

import { BucketTool } from "../tools/BucketTool"
import { CustomNudgeTool } from "../tools/CustomNudgeTool"
import { LDPage } from "../../shared/LDPage"
import { ToolbarPosition } from "../canvas-ui/ToolbarPosition"
import { PublishToolbar } from "../canvas-ui/PublishToolbar"
import { useHashParams } from "../hooks/useHashParams"
import { LDArrowTool } from "../tools/LDArrowTool"
import { TextTool } from "../tools/LDTextTool"
import { MarkerTool } from "../tools/MarkerTool"
import { LiveDraw } from "../LiveDraw"
import { EraserTool } from "../tools/ LDEraserTool"
import { DrawFillTool } from "../tools/DrawFillTool"
import { CustomCursor } from "../components/CustomCursor"
import { LDLineShapeUtil } from "../shapes/LDLineShapeUtil"
import { LDGroupShapeUtil } from "../shapes/LDGroupShapeUtil"
import { LDGeoShapeUtil } from "../shapes/LDGeoShapeUtil"
import { MarkerShapeUtil } from "../shapes/MarkerShapeUtil"
import { FillBindingUtil } from "../shapes/FillBindingUtil"
import { CustomDrawShapeUtil } from "../shapes/CustomDrawShapeUtil"

export function DrawingViewer() {
  const [test, setTest] = useState(false)
  const dispatch = useAppDispatch()

  // initialize
  const { drawingId, pageId } = useParams() as {
    drawingId: DrawingId
    pageId: TLPageId
  }
  const params = useHashParams()

  console.log("params", params)
  useEffect(() => {
    // dispatch(loadDrawing(drawingId))
  }, [])

  const editorRef = useRef<Editor | null>(null)

  const [editingDrawingName, setEditingDrawingName] = useState<string | null>(
    "",
  )

  // initialize the name input
  // useEffect(
  //   function populate() {
  //     if (editorDrawing) {
  //       setEditingDrawingName(
  //         drawingsLookup[editorDrawing.id]?.name ?? "Drawing",
  //       )
  //     }
  //   },
  //   [editorDrawing?.id, drawingsLookup],
  // )

  // const persistDrawing = useCallback(
  //   throttle(async () => {
  //     if (!editorRef.current) return

  //     const { document } = getSnapshot(editorRef.current!.store)
  //     const shapeIds = editorRef.current!.getCurrentPageShapeIds()

  //     const blob = await exportToBlob({
  //       editor: editorRef.current!,
  //       ids: [...shapeIds],
  //       format: "png",
  //     })
  //     dispatch(saveDrawingData(drawingId, document, blob))
  //   }, 500),
  //   [],
  // )

  async function handleSaveSnapshot() {
    // persistDrawing()
  }

  function handleTldrawMount(editor: Editor) {
    // get the stored current page id
    const currentPageId = editor.getDocumentSettings().meta
      .currentPageId as TLPageId

    // window['editor'] = editor

    // apply the stored current page id
    editor.setCurrentPage(pageId)

    editor.updateInstanceState({
      isGridMode: true,
    })
    editor.setCurrentTool("select")

    const targetPage = editor.getPage(pageId) as LDPage

    const pageMeta = targetPage!.meta
    const pageParams = {
      ...pageMeta.parameters,
      ...Object.fromEntries(
        Object.keys(params).map((paramId) => {
          const paramValue = params[paramId]
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return [
            paramId,
            { type: "color", defaultValue: (paramValue as any).value },
          ]
        }),
      ),
    }

    editor.updatePage({
      id: pageId,
      meta: {
        ...targetPage!.meta,
        parameters: pageParams,
      },
    })

    // editor.updatePage({
    //   id: editor.getCurrentPageId(),
    //   meta: /*editor.getCurrentPage().meta ??*/ Page.initial,
    // })

    // editor.createShapes([
    //   ({
    //     id: 'shape:0' as TLShapeId,
    //     type: 'custom-draw',
    //     props: {
    //       isComplete: true,
    //       isClosed: false,
    //       isPen: false,
    //       segments: [
    //         {
    //           type: 'free',
    //           points: [{ x: 10, y: 20 }, { x: 50, y: 450 }, { x: 350, y: 350 }]
    //         } as TLDrawShapeSegment,
    //       ],
    //       scale: 1,
    //       layer: '0',
    //     } as CustomDrawShapeProps
    //   }),
    // ])

    editorRef.current = editor
    // //console.log(editor)

    // editor.store.listen(
    //   (update) => {
    //     //console.log('update', update)
    //   },
    //   { scope: 'document', source: 'user' }
    // )

    // only subscribe to changes to the document

    // editor.updateShapes([

    // ])
  }

  return (
    <IonPage>
      <Tldraw
        // snapshot={{
        //   document: editorDrawing?.data ?? serializedInitialStore,
        //   session: {
        //     version: 0,
        //   },
        // }}
        // initialData={}
        onMount={handleTldrawMount}
        bindingUtils={[...defaultBindingUtils, FillBindingUtil]}
        shapeUtils={[
          ...defaultShapeUtils,
          CustomDrawShapeUtil,
          LDLineShapeUtil,
          LDGroupShapeUtil,
          LDGeoShapeUtil,
          MarkerShapeUtil,
        ]}
        //textOptions={u}
        // overrides={overrides}
        initialState="select"
        tools={[
          DrawStrokeTool,
          DrawFillTool,
          BucketTool,
          CustomNudgeTool,
          LDArrowTool,
          TextTool,
          MarkerTool,
          EraserTool,
        ]}
        // hideUi
        components={{
          Toolbar: null,
          MainMenu: null,
          PageMenu: null,
          // removes the "Exit pen mode" button that shows up after using the pen
          HelperButtons: null,
          Cursor: CustomCursor,
          // will pan with the canvas but won't be affected by zoom
          InFrontOfTheCanvas: () => {
            return null // return <SelectionOptions />
          },
        }}
        forceMobile
      >
        <ToolbarPosition anchor="left" visible={true} style={{ top: 160 }}>
          <PublishToolbar />
        </ToolbarPosition>
      </Tldraw>
    </IonPage>
  )
}
